import { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { useGetAssignedStudentCourses } from '../AssignedStudentCoursesHooks';
import MultipleDateSelector from '../../../../components/date/MultipleDateSelector';
import { filterUndefined } from '../../../../utils/FilterUndefinedObject';

const defaultProps = {
  selectedDates: {},
  onSelectedDatesApply: () => null,
  onStartLoading: () => null,
  subjectId: null,
  onDataLoad: () => null,
  assignedStudentCourses: [],
  filterCriteriaAssignedStudentCourses: {},
};

export default function TeacherCourseAssignmentForDaysAction(props) {
  const mergedProps = { ...defaultProps, ...filterUndefined(props) };
  const {
    selectedDates,
    onSelectedDatesApply,
    onStartLoading,
    subjectId,
    onDataLoad,
    assignedStudentCourses,
    filterCriteriaAssignedStudentCourses,
  } = mergedProps;
  const {
    getAssignedStudentData,
  } = useGetAssignedStudentCourses({
    selectedDates,
    onStartLoading,
    subjectId,
    onDataLoad,
    assignedStudentCourses,
    filterCriteriaAssignedStudentCourses,
  });

  const [internalSelectedDates, setInternalSelectedDates] = useState(selectedDates);

  useEffect(() => {
    setInternalSelectedDates(selectedDates);
  }, [selectedDates]);

  return (
    <Box display='flex' alignItems='center' justifyContent='flex-start'>
      <MultipleDateSelector
        selectedDates={internalSelectedDates}
        onSelectedDatesChange={(dates) => {
          setInternalSelectedDates(dates);
        }}
        onApply={async () => {
          await onSelectedDatesApply(internalSelectedDates);
          getAssignedStudentData(internalSelectedDates);
        }}
        highlightToday={false}
        showText={false}
      />
    </Box>
  );
}
